export enum FhaSegment {
  RAW = 'fha.raw',
  SCOUTING = 'fha.rank',
  TRUE_COLOR = 'fha.true-color',
  VEGETATION = 'fha.abs',
}

export const FHA_KEY = 'fha';
